<div class="top-banner-row">
  <div class="top-banner-row__body">
    @if (title || textContent || hasHtmlBody) {
      <div
        #headerRef
        class="top-banner-row__header"
        [class.top-banner-row__header--clamped]="hasBodyContent && isClamped">
        @if (title) {
          <span class="top-banner-row__title">{{ title }}</span>
        }
        @if (hasHtmlBody) {
          @if (title) {
            <span class="top-banner-row__title-separator"> – </span>
          }
          <span class="top-banner-row__html" [innerHTML]="htmlContent"></span>
        } @else if (textContent) {
          @if (title) {
            <span class="top-banner-row__title-separator"> – </span>
          }
          <span class="top-banner-row__text">{{ textContent }}</span>
        }
      </div>
    }
    @if (showExpandToggle) {
      <button type="button" class="top-banner-row__toggle" (click)="toggleExpand()">
        {{ expanded ? ("shared.showLess" | translate) : ("shared.showMore" | translate) }}
      </button>
    }
  </div>
  <button
    type="button"
    class="top-banner-row__close"
    (click)="onDismiss()"
    [matTooltip]="'shared.closeSystemMessage' | translate"
    [attr.aria-label]="'shared.close' | translate">
    <img
      [ngSrc]="closeIconUrl"
      alt=""
      width="16"
      height="16"
      loading="lazy" />
  </button>
</div>
